<template>
  <span 
    class="vip-badge" 
    :class="{ 'is-vip': isVip, 'is-mini': type === 'mini' }" 
    :title="vipTooltip"
  >
    {{ isVip ? 'VIP' : '普通用户' }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

interface Props {
  level: number;
  expiresAt?: string | null;
  type?: 'default' | 'mini'; // mini用于导航栏等小型显示
}

const props = defineProps<Props>();

const isVip = computed(() => props.level > 0);

const vipTooltip = computed(() => {
  if (!isVip.value) return '普通用户';
  if (!props.expiresAt) return 'VIP用户';
  return `VIP用户 - 到期时间: ${new Date(props.expiresAt).toLocaleDateString('zh-CN')}`;
});
</script>

<style scoped>
.vip-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 14px;
  background-color: #f4f4f5;
  color: #909399;
  transition: all 0.3s ease;
}

.vip-badge.is-vip {
  background-color: #f0f9eb;
  color: #67c23a;
}

/* mini样式用于导航栏和用户名旁边的小标签 */
.vip-badge.is-mini {
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 6px;
  background-color: #f0f9eb;
  color: #67c23a;
}

.vip-badge.is-mini.is-vip {
  background-color: #f0f9eb;
  color: #67c23a;
  border: 1px solid #e1f3d8;
}
</style> 